import { BUG_STATUSES, CHORE_STATUSES, RELEASE_STATUSES, STORY_STATUSES } from '@/constants/STORY_STATUSES.ts'
import { STORY_TYPES } from '@/constants/STORY_TYPES'
import { isTemporaryId } from '@/utils/key.ts'

export const isPointAssignable = (storyType: StoryType): boolean => {
  return storyType === STORY_TYPES.FEATURE || storyType === STORY_TYPES.DESIGN
}

export const getPossibleStatusesByStoryType = (storyType: StoryType) => {
  switch (storyType) {
    case STORY_TYPES.BUG:
      return BUG_STATUSES
    case STORY_TYPES.CHORE:
      return CHORE_STATUSES
    case STORY_TYPES.RELEASE:
      return RELEASE_STATUSES
    default:
      return STORY_STATUSES
  }
}

export const isStartableStory = (storyId: string, estimate: StoryPoints, storyType: StoryType): boolean => {
  return !(isTemporaryId(storyId) || (estimate === -1 && isPointAssignable(storyType)))
}

export const getStatusByGroup = (group: StoryGroup): StoryStatus => {
  switch (group) {
    case 'scheduled':
      return STORY_STATUSES.UNSTARTED
    default:
      return STORY_STATUSES.UNSCHEDULED
  }
}

export const submitResidualData = (storyId: string) => {
  const autoUpdateButtons = document.querySelectorAll(
    `#story_${storyId} button[data-update-onformclose]`,
  ) as NodeListOf<HTMLButtonElement>
  for (const autoUpdateButton of autoUpdateButtons) {
    autoUpdateButton.click()
  }
}
